import React from 'react';
import { Paper, Box, Skeleton, SxProps, styled, Stack } from '@mui/material';

export interface IMyTeamCardSkeletonProps {
  id: string;
  sxProps?: SxProps;
}

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const CandidatesActivityReviewSkeleton = ({
  id,
  sxProps,
}: IMyTeamCardSkeletonProps) => (
  <Paper
    id={`${id}-skeleton`}
    data-testid={`${id}-skeleton`}
    variant='outlined'
    sx={{
      minHeight: '6.25rem',
      borderRadius: '1rem',
      ...sxProps,
    }}
  >
    <Box data-testid='box-skeleton' sx={{ p: '0.75rem 1rem' }}>
      <Stack direction='row' spacing={2} sx={{ alignItems: 'center' }}>
        <Item sx={{ width: '100%', border: 'none', p: 0 }}>
          <Skeleton
            variant='rectangular'
            width='45%'
            height={24}
            sx={{
              mb: '0.625rem',
              bgcolor: (theme) => theme.palette.neutral?.main,
            }}
          />
          <Skeleton
            variant='rectangular'
            width='50%'
            height={24}
            sx={{
              mb: '0.625rem',
              bgcolor: (theme) => theme.palette.neutral?.main,
            }}
          />
          <Skeleton
            variant='rectangular'
            width='75%'
            height={24}
            sx={{ bgcolor: (theme) => theme.palette.neutral?.main }}
          />
        </Item>
        <Item
          sx={{
            width: '39%',
            border: 'none',
            textAlign: '-webkit-right',
            p: 0,
          }}
        >
          <Skeleton
            variant='rectangular'
            width='100%'
            height={24}
            sx={{
              mb: '0.625rem',
              bgcolor: (theme) => theme.palette.neutral?.main,
            }}
          />
        </Item>
      </Stack>
    </Box>
  </Paper>
);

export default CandidatesActivityReviewSkeleton;
